var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5326 183.333L75.6993 129.167H129.866V75L184.033 129.167L129.866 183.333H21.5326Z",
    fill: "#E4E4E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5326 75L75.6993 129.167V75H129.866L184.033 20.8334H75.6993L21.5326 75Z",
    fill: "#E4E4E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTransparent);
export default __webpack_public_path__ + "static/media/logo-transparent.ab738e3aedfeb1d0e33845fc7e1163ca.svg";
export { ForwardRef as ReactComponent };